<template>
  <div>
    <form action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Adding a new floor</p>
        </header>
        <section class="modal-card-body">
          <b-field>
            <b-upload v-model="droppedFile" native drag-drop>
              <section class="section">
                <div class="content has-text-centered">
                  <div>
                    <div>
                      <img v-bind:src="uploadedImageSrc" height="100" width="100" />
                    </div>
                    <div v-if="droppedFile === undefined">
                      Drop image here or click to upload
                      <div>
                        <b-icon icon="upload"></b-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div align="left">
            <b-field>
              <b-input placeholder="Floor name" v-model="newFloorName" style></b-input>
            </b-field>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
            aria-label="Cancel operation"
          >Cancel</button>
          <button
            class="button is-primary"
            type="button"
            @click="floorAdded"
            v-bind:disabled="addButtonDisabled"
            aria-label="Add floor"
          >
            <div>Add floor</div>

            <b-loading :is-full-page="true" :active.sync="uploadHappening" :can-cancel="false"></b-loading>
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { addFloor } from "../api-requests";

// TOOD:
// - Add max length to input fields.
// - Sanitize input fields too
export default {
  name: "FloorModal",
  data: function() {
    return {
      droppedFile: undefined,
      newFloorName: "",
      uploadedImageSrc: "",
      uploadHappening: false
    };
  },
  computed: {
    addButtonDisabled: function() {
      const shouldBeDisabled =
        this.droppedFile === undefined || this.newFloorName === "";
      return shouldBeDisabled;
    }
  },
  watch: {
    droppedFile: function(oldFile, newFile) {
      var reader = new FileReader();
      var output = document.getElementById("output");
      var self = this;
      reader.addEventListener(
        "load",
        function() {
          self.uploadedImageSrc = reader.result;
        },
        false
      );
      reader.readAsDataURL(this.droppedFile);
      console.log(this.droppedFile.name);
    }
  },
  methods: {
    floorAdded: async function() {
      this.uploadHappening = true;
      try {
        await addFloor(
          this.newFloorName,
          this.$store.state.selectedBuildingId,
          this.uploadedImageSrc
        );
      }
      finally {
        this.uploadHappening = false;
      }

      this.$parent.close();
    }
  }
};
</script>